import React, { useState, useEffect } from 'react';
import {  BREADCRUMB_LINKS, FINAL_RESUME, NEXT_LABEL, } from '../constants/constants';
import { Redirect } from 'react-router';
import PartyPopper from '../assets/images/Party_Popper_Icon.svg';
import { useResume } from '../context/ResumeContext';
import QuickTipsBlock from './common/QuickTipsBlock';

const EditorSectionsTips = ({ splash, section, nextSection, previousSection }) => {

    //Component asked to redirect, first validate
    const [callOnce, setcallOnce] = useState(false)
    //Flag is Do Next redirect
    const [redirectNext, setredirectNext] = useState(false)
    //Flag is Do Back redirect
    const [redirectBack, setredirectBack] = useState(false)
    const {
        resume: {
            heading: { email },//Used to intentify component is ignored with first call with initial-data, and react with second time component is called with user input data
            enabled_tabs,
            skipped_sections
        },
        handlers: {
            nuteralizeNextClick,
            nuteralizeBackClick
        },
        next_clicked,
        back_clicked,
    } = useResume();
    const QEM = enabled_tabs.includes('completed')
    const skipped = skipped_sections?.includes(section)
    const label = (l) => QEM ? NEXT_LABEL : l
    const rURL = (u) => QEM ? FINAL_RESUME : u
    const nextClicked = () => {
        if (next_clicked) {//Set for next page
            nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped ? 'Add' : 'Skip' })
            return true
        } else {//Set for own page
            // if (next_clicked || next_label != label(NEXT_SUMMARY_LABEL)) {
            //Always run for next click and self label not matched
            nuteralizeNextClick({ next_label: label(NEXT_LABEL), skip_label: skipped ? 'Add' : 'Skip' })
            return false
            //}
        }
    }

    const backClicked = () => {
        if (back_clicked) {
            nuteralizeBackClick({ next_label: label(NEXT_LABEL) })
            return true
        }
    }
    useEffect(() => {
        if (nextClicked()) setredirectNext(true)
        else setredirectNext(false)
        if (backClicked()) setredirectBack(true)
        else setredirectBack(false)
        setcallOnce(false)
    }, [callOnce, email]);

    if ((next_clicked || back_clicked) && !callOnce) setcallOnce(true);
    // if (!active_tabs.includes('summary')) return <Redirect to={HEADING_LINK} />
    if (redirectNext) { history.pushState(null, location.href); return <Redirect to={nextSection} /> }
    if (redirectBack) return <Redirect to={rURL(previousSection)} />
    return (<>
        {/* <div className="editor-block-inner">
            <div className="tips-outer">
                <h2 className='tips-heading'><span className='party-icon'><PartyPopper /></span>{BREADCRUMB_LINKS[section== 'education_history' ? 'education' : section]?.tipspage_heading}</h2>
                <QuickTipsBlock section={section} />
            </div>
        </div> */}
    </>);
}

export default EditorSectionsTips;

